export function prepareGreyNoiseConfig(config) {
  const apiToken = config.api_token;
  if (apiToken && "is_set" in apiToken) {
    return {
      ...config,
      api_token: apiToken.is_set ? { keep_value: true } : { set_value: "" }
    };
  }
  return config;
}
